var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',{staticClass:"famiglia"},[_c('h1',[_vm._v(_vm._s(_vm.famiglia))])]),_c('div',[(
        (_vm.visibilityData === 'ZEK' || _vm.visibilityData === 'ZEB') && !_vm.isEnglish
      )?_c('p',{staticClass:"alert-box-custom"},[_vm._v(" L'articolo è fuori produzione, disponibile fino ad esaurimento scorte o su richiesta. ")]):_vm._e(),(
        (_vm.visibilityData === 'ZEK' || _vm.visibilityData === 'ZEB') && _vm.isEnglish
      )?_c('p',{staticClass:"alert-box-custom"},[_vm._v(" This item is available until stocks run out or upon request. ")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }